export const USER_ID = '01234567-89ab-cde0-1234-567890abcdef';

//v-mask
export const PHONE_MASK = '+7 (###) ###-##-##';
export const INN_MASK = '############';

//placeholder
export const PHONE_PLACEHOLDER = '+7 (999) 999-99-99';